import React from 'react';
import { Alert, AlertIcon, Box, Button } from '@chakra-ui/react';

interface ServicePaymentConfirmationProps {
  appointmentType: any;
  borderColor: string;
  isServiceBooking: boolean;
  handlePaymentNo: () => void;
  handlePaymentYes: () => void;
  isPatientValid: boolean;
  servicebookingFlowStore?: any;
}

export const ServicePaymentConfirmation: React.FC<ServicePaymentConfirmationProps> = ({
  appointmentType,
  borderColor,
  isServiceBooking,
  handlePaymentNo,
  handlePaymentYes,
  isPatientValid,
  servicebookingFlowStore
}) => {
  return (
    <>
      <Alert 
        status='info'
        variant="subtle"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        width={{ base: "100%", md: "70%" }}
      >
        <AlertIcon boxSize="40px" mr={0} mb={2} />
        <div dangerouslySetInnerHTML={{ 
          __html: appointmentType?.pre_payment_req === '1' 
            ? appointmentType?.pre_payment_msg 
            : appointmentType?.post_billing_msg 
        }} />
      </Alert>
      
      <Box display="flex" justifyContent="space-between" gap={5} p={5}>
        <Button
          width="100%"
          onClick={handlePaymentNo}
          borderRadius="30px"
          border={`2px solid ${borderColor}`}
          color={isServiceBooking ? servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg : "#B92F2F"}
          bg="transparent"
          _hover={{ 
            bg: isServiceBooking ? servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg : "#B92F2F", 
            color: "#fff" 
          }}
        >
          No
        </Button>
        <Button 
          width="100%" 
          onClick={handlePaymentYes} 
          // isDisabled={!isPatientValid}
          borderRadius={30} 
          bg={isServiceBooking ? servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg : "#B92F2F"}
          color="#fff"
        >
          Yes
        </Button>
      </Box>
    </>
  );
};